import {EventEmitter, Injectable, OnInit} from '@angular/core';
import {SettingItem} from '../domain/setting-item';
import {RestService} from './rest.service';
import {Tooltip} from '../domain/tooltip';
import {Textblock} from '../domain/textblock';
import {ValidationConstraint} from '../domain/validation-constraint';

@Injectable({
    providedIn: 'root'
})
export class ConfigService implements OnInit {

    configLoaded = new EventEmitter();
    tooltipsLoaded = new EventEmitter<Tooltip[]>();
    textblocksLoaded = new EventEmitter<Textblock[]>();
    validationConstraintsLoaded = new EventEmitter<ValidationConstraint[]>();
    private tooltips: Tooltip[];
    private textblocks: Textblock[];

    private config = {
        TowCase: null, MinimalTowCase: null
    };

    private validationConstraints: any = {};
    private loadingConfig = false;
    private loadingValidationConstraints = false;
    private loadingTooltips = false;
    private monthOptions = [];


    constructor(private restService: RestService) {
        for (let i = 1; i <= 12; i++) {
            this.monthOptions.push({display: (i + '').padStart(2, '0'), value: i});
        }
    }

    public onAppChange() {
        delete this.textblocks;
        delete this.tooltips;
    }

    getConfig(caseType?: string) {

        if (!this.config[caseType]) {
            if (!this.loadingConfig) {
                this.loadConfig(caseType);
                this.loadingConfig = true;
            }
            return null;
        }
        return this.config[caseType];
    }

    getConfigById(ids: string[]) {
        let url = '/config/client-setting?';
        const parts = [];
        ids.forEach(id => {
            parts.push('id=' + id);
        });
        const partsArray = new Array(parts);
        url += partsArray.join('&');
        this.restService.get<SettingItem[]>(url).then((result) => {
                const config = this.parseConfigObject(result);
                this.configLoaded.emit(config);
            }
        );
    }


    getValidationConstraints(caseType: string) {
        if (!this.validationConstraints[caseType]) {
            if (!this.loadingValidationConstraints) {
                this.loadValidationConstraint(caseType);
                this.loadingValidationConstraints = true;
            }
            return null;
        }
        return this.validationConstraints[caseType];
    }

    getTooltips() {
        if (this.tooltips === undefined) {
            if (!this.loadingTooltips) {
                this.loadTooptips();
                this.loadingTooltips = true;
            }

            return null;
        }
        return this.tooltips;
    }

    unsetTooltips() {
        delete this.tooltips;
    }

    getTextblocks() {
        if (this.textblocks === undefined) {
            this.loadTextblocks();
            return null;
        }
        return this.textblocks;
    }

    ngOnInit(): void {
        this.loadConfig('TowCase');
        this.loadTooptips();
        this.loadTextblocks();
    }

    private loadValidationConstraint(caseType: string) {
        this.restService.get<ValidationConstraint[]>('/config/validation-constraint/' + caseType).then((data) => {
            this.validationConstraints[caseType] = data;
            this.loadingValidationConstraints = false;
            this.validationConstraintsLoaded.emit(data);
        });
    }

    private loadConfig(caseType: string) {
        let url = '/config/client-setting';
        if (caseType !== undefined) {
            url = url + '/' + caseType;
        }

        this.restService.get<SettingItem[]>(url).then((result) => {
                const config = this.parseConfigObject(result);
                this.config[caseType] = config;
                this.loadingConfig = false;
                this.configLoaded.emit(config);
            }
        );
    }

    private parseConfigObject(result: SettingItem[]) {
        const config = {};
        for (const item of result) {
            if (config[item.key] === undefined) {
                config[item.key] = [];
            }

            if (item.key === 'start_year') {
                config['datetime_year'] = this.buildYearOptions(item.value);
            }

            switch (item.valueType) {
                case 'BOOL':
                    config[item.key].push({display: item.display, value: item.value === 'true'});
                    break;

                case 'INTEGER':
                    config[item.key].push({display: item.display, value: parseInt(item.value, 10)});
                    break;

                case 'FLOAT':
                    config[item.key].push({display: item.display, value: parseFloat(item.value)});
                    break;

                case 'STRING':
                default:
                    config[item.key].push({display: item.display, value: item.value});
                    break;
            }
        }
        config['datetime_month'] = this.monthOptions;

        return config;
    }

    private loadTooptips() {
        this.restService.get<Tooltip[]>('/config/tooltips').then((data) => {
            this.tooltips = data;
            this.loadingTooltips = false;
            this.tooltipsLoaded.emit(data);
        });
    }

    private loadTextblocks() {
        this.restService.get<Textblock[]>('/config/textblocks').then((data) => {
            this.textblocks = data;
            this.textblocksLoaded.emit(data);
        });
    }

    private buildYearOptions(value: string) {
        const currentYear = new Date().getFullYear();
        const startYear = parseInt(value, 10);
        const options = [];
        for (let i = currentYear; i >= startYear; i--) {
            options.push({display: i, value: i});
        }
        return options;
    }

}
